import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetSyncTableStates = (): Promise<any> =>
    request({
        url: ApiURL.Query.GetSyncTableStates,
        method: RequestType.GET,
    });

const SyncTableStateQuery = {
    GetSyncTableStates,
};

export default SyncTableStateQuery;
